<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>System</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in system..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('name')">Name</th>
              <th class="col-1" @click="toggleSort('value')">Value</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>

              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.name">
              <td class="col-1 text-truncate" v-html="truncateText(config.name, 30)" @click="selectText" :data-text="config.name"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.value, 30)" @click="selectText" :data-text="config.value"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'SystemEdit', params: { id: config.name, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";

export default {
  name: "System",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      SystemList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
      selectedApp: '',
    };
  },
  computed: {
    filteredCouponsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.SystemList.filter((config) => {
        return (
            (config.name && config.name.toString().includes(search)) ||
            (config.value && config.value.toLowerCase().includes(search)) ||
            (config.application && config.application.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      //Show only the entries that belong to the selected application
      if (this.selectedApp !== '') {
        filteredList = filteredList.filter(item => item.application === this.selectedApp);
      }
      return filteredList;
    },
    sortData() {
      return this.filteredCouponsList;
    },
  },
  created() {
    const appCookie = Cookies.get('application');
    if (appCookie) {
      this.selectedApp = appCookie;
    }
    this.doLoadSystem();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'name';
  },
  methods: {
    doLoadSystem() {
      AdminService.getSystemList().then((data) => {
        this.SystemList = data;
      }).catch((error) => {
        console.error("Error loading system:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      if (text === undefined || text ===null) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    redirectToCreate() {
      this.$router.push({ name: 'SystemCreate' }); // Navigate to the StripeEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>
